<script lang="ts">
	import { mathNormalize } from 'src/helpers/utilities';
	import type { ButtonTimer } from 'src/helpers/xt1_helpers/irrigation/irrigation_helpers';

	export let isActive: boolean;
	export let done: boolean;
	export let color: string;
	export let buttonTimer: ButtonTimer;
	export let fillNumber: number | null = null;
	export let disabled = false;

	$: offset = done ? 0 : mathNormalize(buttonTimer?.percentage ?? 100, 0, 100);
</script>

<div class="zone-controls">
	<svg
		class="countdown-visualizer"
		viewBox="0 0 36 36"
		style="--offset:{offset}; --step:1s"
		aria-hidden="true"
	>
		<circle class="track" cx="18" cy="18" r="13" style="stroke: {color}" />
		<circle class="track" cx="18" cy="18" r="17.25" style="stroke: {color}" />
		{#if done || (buttonTimer?.time > 0 && buttonTimer?.percentage < 100)}
			<circle class="progress" cx="18" cy="18" r="15.5" style="stroke: {color}" />
		{/if}
	</svg>
	<button
		{disabled}
		type="button"
		aria-pressed={isActive}
		style={disabled ? 'pointer-events: none;' : ''}
		class={`zone-btn ${isActive ? 'stop' : 'play'}-btn`}
		on:click
	>
		{#if fillNumber !== null}
			<span class="fill-number{done ? ' done' : ''}" style="background: {color}">{fillNumber}</span
			>
		{:else}
			<i class={done ? 'fat fa-check' : isActive ? 'fat fa-stop' : 'fat fa-play'}></i>
		{/if}
	</button>
</div>

<style>
	.zone-controls {
		position: relative;
		display: flex;
		align-items: center;
		gap: 12px;
	}
	.zone-btn {
		width: 40px;
		height: 40px;
		border-radius: 50%;
		border: none;
		cursor: pointer;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 14px;
		transition: all 0.2s ease;
		position: relative;
		z-index: 1;
	}
	button {
		background: #121517;
		color: white;
	}
	button:hover {
		background: #2c2c2e;
	}
	button i.fa-play {
		padding-left: 2px;
	}
	.countdown-visualizer {
		position: absolute;
		inset: 0;
		margin: auto;
		width: 40px;
		height: 40px;
		pointer-events: none;
		z-index: 2;
	}
	circle {
		fill: none;
	}
	circle.progress {
		/* stroke-linecap: round; */
		stroke-width: 5px;
		transform: rotate(-90deg);
		transform-origin: 50% 50%;
		stroke-dasharray: 100;
		stroke-dashoffset: var(--offset);
		transition: stroke-dashoffset var(--step) linear;
		will-change: stroke-dashoffset;
	}
	circle.track {
		stroke-width: 1px;
	}
	.fill-number {
		position: absolute;
		width: 29px;
		height: 29px;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 14px;
		font-weight: 600;
	}
	.fill-number.done {
		width: 100%;
		height: 100%;
	}
</style>
